import {authHeader} from "../helpers/auth-header";

export const manageService = {
    deleteDemand,
    deleteSupply,
    updateDemand,
    updateSupply,
};

function deleteDemand(id){
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    };

    return fetch(process.env.VUE_APP_ROOT_API + '/demands/delete/' + id, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function deleteSupply(id){
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    };

    return fetch(process.env.VUE_APP_ROOT_API + '/supplies/delete/' + id, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function updateDemand(id, qty){
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, qtyRequiredNow: qty })
    };

    return fetch(process.env.VUE_APP_ROOT_API + '/demands/' + id, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function updateSupply(id, qty){
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, qtyAvailableNow: qty })
    };

    return fetch(process.env.VUE_APP_ROOT_API + '/supplies/' + id, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            return Promise.reject(data);
        }
        return data;
    });
}
